// The IC POV Opportunities list: the opportunities that have POC/POV SE activities in Salesforce (from
// `sf/team/pov-activity-summary/?detail=1`), enriched with the POV product rows and ownership fields of the same
// opportunity from `opportunities-pov-lean` when it has them.

import type { PovActivityItem, PovActivityOpportunity } from '../hooks/useSfTeamPovActivitySummary';

export interface PovActivityOppRow {
  oppId: string;
  accountId: string;
  name: string;
  accountName: string | null;
  amount: number | null;
  stage: string | null;
  closeDate: string | null;
  ownerName: string | null;
  rm: string | null;
  portfolioAe: string | null;
  sl4: string | null;
  sl5: string | null;
  activities: PovActivityItem[];
  povRows: any[];
}

/** Only opportunities with at least one activity, each joined to its lean-data twin (by id) when there is one. */
export function povOpportunitiesWithActivities(
  detailOpps: PovActivityOpportunity[] | null | undefined,
  leanOpps: any[] | null | undefined,
): PovActivityOppRow[] {
  const leanById = new Map<string, any>();
  for (const o of leanOpps ?? []) leanById.set(String(o?.id ?? o?.Id ?? ''), o);

  return (detailOpps ?? [])
    .filter((o) => (o.activities?.length ?? 0) > 0)
    .map((o) => {
      const lean = leanById.get(o.id);
      return {
        oppId: o.id,
        accountId: String(o.account_id ?? lean?.AccountId ?? ''),
        name: String(o.name ?? lean?.Name ?? ''),
        accountName: o.account_name ?? lean?.AccountName ?? null,
        amount: o.amount ?? lean?.Amount ?? null,
        stage: o.stage ?? lean?.StageName ?? null,
        closeDate: o.close_date ?? lean?.CloseDate ?? null,
        ownerName: lean?.OwnerName ?? null,
        rm: lean?.rm ?? null,
        portfolioAe: lean?.Cisco_AM__c ?? null,
        sl4: lean?.Cisco_Terr_4__c ?? null,
        sl5: lean?.Cisco_Terr_5__c ?? null,
        activities: o.activities,
        povRows: Array.isArray(lean?.pov_rows) ? lean.pov_rows : [],
      };
    });
}
